// extracted by mini-css-extract-plugin
export var content = "styles-module--content--8f0b5";
export var layout = "styles-module--layout--cb1a8";
export var light = "styles-module--light--6d66c";
export var wrapper = "styles-module--wrapper--956cb";